import { IconButton, Tooltip } from '@mui/material'
import DeleteOutlineRoundedIcon from '@mui/icons-material/DeleteOutlineRounded'

interface DeleteIconButtonProps {
  onClick?: () => void
  disabled?: boolean
  isDark?: boolean
  title?: string
}

// Shared icon-only delete action used in the config grid row action columns.
// Soft-red rounded square that darkens on hover; theme-aware for light/dark.
const DeleteIconButton = ({
  onClick,
  disabled = false,
  isDark = false,
  title = 'Delete',
}: DeleteIconButtonProps) => {
  const color = isDark ? '#f87171' : '#d32f2f'
  const hover = isDark ? '#fca5a5' : '#c62828'

  return (
    <Tooltip title={title}>
      {/* span wrapper so the tooltip still works while the button is disabled */}
      <span>
        <IconButton
          disabled={disabled}
          onClick={onClick}
          sx={{
            width: '28px',
            height: '28px',
            borderRadius: '6px',
            color,
            border: `1px solid ${
              isDark ? 'rgba(248, 113, 113, 0.45)' : '#f1b6b6'
            }`,
            backgroundColor: isDark ? 'rgba(248, 113, 113, 0.08)' : '#fff2f2',
            transition:
              'color .2s ease, border-color .2s ease, background-color .2s ease',
            '&:hover': {
              color: hover,
              borderColor: hover,
              backgroundColor: isDark
                ? 'rgba(248, 113, 113, 0.16)'
                : '#ffe1e1',
            },
            '&.Mui-disabled': { opacity: 0.4 },
          }}
        >
          <DeleteOutlineRoundedIcon sx={{ fontSize: 17 }} />
        </IconButton>
      </span>
    </Tooltip>
  )
}

export default DeleteIconButton
